import React from 'react'
import Introduction from './Introduction';
import CollaborationTeam from "./CollaborationTeam"
import FinancialServices from "./FinancialServices"
import ContactWithUs from "./ContactWithUs"
import Header from "./Header"
export default function LandingPage() {

    return (
        <div style={{backgroundColor : "#F5F5F5"}}>
            <Header />
            <Introduction/>
            <CollaborationTeam />
            <FinancialServices/>
            <ContactWithUs/>
        </div>
    )
}